"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Const_1 = __importDefault(require("../Const"));
const zod_1 = require("zod");
const User_1 = __importDefault(require("./User"));
var Chat;
(function (Chat) {
    Chat.messageSchema = zod_1.z.object({
        audioUrl: zod_1.z.string().nullable(),
        chatMessageId: zod_1.z.string().uuid(),
        content: zod_1.z.string().nullable(),
        createdAt: zod_1.z.coerce.date(),
        deliveredAt: zod_1.z.coerce.date().nullable(),
        fromUserId: zod_1.z.string().uuid(),
        readAt: zod_1.z.coerce.date().nullable(),
        toUserId: zod_1.z.string().uuid(),
        type: zod_1.z.nativeEnum(Const_1.default.chatMessageType),
        updatedAt: zod_1.z.coerce.date(),
    });
    Chat.chatSchema = zod_1.z.object({ lastMessage: Chat.messageSchema.optional(), profile: User_1.default.profileBaseSchema });
    Chat.listParamsSchema = zod_1.z.object({
        limit: zod_1.z.number().optional(),
        offset: zod_1.z.number().optional(),
        query: zod_1.z.string().optional(),
    });
    Chat.listReturnSchema = zod_1.z.object({ count: zod_1.z.number(), chats: Chat.chatSchema.array() });
    Chat.queryMessagesParamsSchema = zod_1.z.object({
        limit: zod_1.z.number().optional(),
        offset: zod_1.z.number().optional(),
        userId: zod_1.z.string().uuid(),
    });
    Chat.queryMessagesReturnSchema = zod_1.z.object({ count: zod_1.z.number(), messages: Chat.messageSchema.array() });
    Chat.readMessagesParamsSchema = zod_1.z.object({ userId: zod_1.z.string().uuid() });
    Chat.readMessagesReturnSchema = zod_1.z.object({});
    Chat.reportMessageParamsSchema = zod_1.z.object({ chatMessageId: zod_1.z.string().uuid() });
    Chat.reportMessageReturnSchema = zod_1.z.object({});
    Chat.sendMessageParamsSchema = zod_1.z.object({ content: zod_1.z.string(), userId: zod_1.z.string().uuid() });
    Chat.sendMessageReturnSchema = Chat.messageSchema;
    Chat.sendVoiceMessageParamsSchema = zod_1.z.object({ userId: zod_1.z.string().uuid() });
    Chat.sendVoiceMessageReturnSchema = Chat.messageSchema;
    Chat.statParamsSchema = zod_1.z.object({});
    Chat.statReturnSchema = zod_1.z.object({ unreadMessages: zod_1.z.number() });
    class Adapter {
        reportMessage(params) {
            return __awaiter(this, void 0, void 0, function* () {
                const { chatMessageId } = Chat.reportMessageParamsSchema.parse(params);
                const response = yield this.api.request({ method: "POST", path: `/chat/${chatMessageId}/report` });
                return Chat.reportMessageReturnSchema.parse(response);
            });
        }
        list() {
            return __awaiter(this, arguments, void 0, function* (params = {}) {
                const data = Chat.listParamsSchema.parse(params);
                const response = yield this.api.request({ data, method: "GET", path: `/chat` });
                return Chat.listReturnSchema.parse(response);
            });
        }
        queryMessages(params) {
            return __awaiter(this, void 0, void 0, function* () {
                const _a = Chat.queryMessagesParamsSchema.parse(params), { userId } = _a, data = __rest(_a, ["userId"]);
                const response = yield this.api.request({ data, method: "GET", path: `/chat/dm/${userId}` });
                return Chat.queryMessagesReturnSchema.parse(response);
            });
        }
        readMessages(params) {
            return __awaiter(this, void 0, void 0, function* () {
                const { userId } = Chat.readMessagesParamsSchema.parse(params);
                const response = yield this.api.request({ method: "POST", path: `/chat/dm/${userId}/read` });
                return Chat.readMessagesReturnSchema.parse(response);
            });
        }
        constructor(params) {
            this.api = params.api;
        }
        stat() {
            return __awaiter(this, arguments, void 0, function* (_ = {}) {
                const response = yield this.api.request({ method: "GET", path: `/chat/stat` });
                return Chat.statReturnSchema.parse(response);
            });
        }
    }
    Chat.Adapter = Adapter;
})(Chat || (Chat = {}));
exports.default = Chat;
